import { IJsbridge, IJsonOption } from '../typings';
import { DEFAULT_OPTIONS } from '../constants';

// eslint-disable-next-line
export default function(jsbridge: IJsbridge): IJsbridge {
  return {
    callHandler(name: string, data: any, options?: IJsonOption) {
      return new Promise((resolve, reject) => {
        const requiredOptions: Required<IJsonOption> = {
          ...DEFAULT_OPTIONS,
          ...options,
        };

        // 设置超时返回
        const timeoutID = setTimeout(() => {
          reject(requiredOptions.timeoutError);
        }, requiredOptions.timeoutTime);

        jsbridge.callHandler(name, data).then((result) => {
          clearTimeout(timeoutID);
          return JSON.parse(result);
        }).then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        });
      });
    },
  };
}
